var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col items-center mb-6" }, [
      _c("div", { staticClass: "px-4 mb-6" }, [
        _c("img", {
          staticClass:
            "shadow rounded max-w-full h-auto align-middle border-none",
          staticStyle: { width: "150px" },
          attrs: {
            alt: "...",
            src: _vm.input.avatar ? _vm.input.avatar : _vm.imgPlaceholder
          }
        })
      ]),
      _vm._v(" "),
      _vm.isErrorImage
        ? _c(
            "div",
            { staticClass: "flex flex-col mb-2" },
            [
              _vm.isErrorImage
                ? _c("text-error", { attrs: { text: "Image is required" } })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          !_vm.input.avatar
            ? _c("Button", {
                attrs: { label: "Browse File" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "any",
                      fn: function() {
                        return [
                          _c("input", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              position: "absolute",
                              left: "0",
                              top: "0",
                              opacity: "0",
                              cursor: "pointer",
                              "z-index": "2"
                            },
                            attrs: { type: "file", name: "profile_picture" },
                            on: { change: _vm.onFileChange }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2462335240
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.input.avatar
            ? _c("Button", {
                attrs: { label: "Cancel", variant: "default" },
                on: { clicked: _vm.changeImage }
              })
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "flex gap-6" }, [
      _c(
        "div",
        { staticClass: "flex w-1/2 flex-col" },
        [
          _c("form-item", {
            attrs: { label: "Full Name" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "Full Name",
                        error:
                          _vm.$v.input.name.$dirty &&
                          (!_vm.$v.input.name.required ||
                            !_vm.$v.input.name.maxLength),
                        maxlength: "100"
                      },
                      model: {
                        value: _vm.input.name,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "name", $$v)
                        },
                        expression: "input.name"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill your name." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.name.$dirty && !_vm.$v.input.name.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text: "Max length Video name is 100 character."
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("form-item", {
            attrs: { label: "Email" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function() {
                  return [
                    _c("Input", {
                      attrs: {
                        placeholder: "Email",
                        error: _vm.isErrorEmail,
                        maxlength: "100"
                      },
                      model: {
                        value: _vm.input.email,
                        callback: function($$v) {
                          _vm.$set(_vm.input, "email", $$v)
                        },
                        expression: "input.email"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex flex-col pt-2" },
                      [
                        _vm.$v.input.email.$dirty &&
                        !_vm.$v.input.email.required
                          ? _c("text-error", {
                              attrs: { text: "Please fill your email." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.email.$dirty && !_vm.$v.input.email.email
                          ? _c("text-error", {
                              attrs: { text: "Please fill your correct email." }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.$v.input.email.$dirty &&
                        !_vm.$v.input.email.maxLength
                          ? _c("text-error", {
                              attrs: {
                                text: "Max length Video name is 100 character."
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.emailErrorMessage.length > 0
                          ? _c("text-error", {
                              attrs: { text: _vm.emailErrorMessage }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm.isArtist
            ? _c("form-item", {
                attrs: { label: "Birthdate" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("Input", {
                            attrs: {
                              type: "date",
                              placeholder: "Birthdate",
                              error:
                                _vm.$v.input.dob.$dirty &&
                                !_vm.$v.input.dob.required
                            },
                            model: {
                              value: _vm.input.dob,
                              callback: function($$v) {
                                _vm.$set(_vm.input, "dob", $$v)
                              },
                              expression: "input.dob"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col pt-2" },
                            [
                              _vm.$v.input.dob.$dirty &&
                              !_vm.$v.input.dob.required
                                ? _c("text-error", {
                                    attrs: {
                                      text: "Please fill your birthdate."
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2203478379
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isArtist
            ? _c("form-item", {
                attrs: { label: "Bio" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c(
                            "div",
                            { staticClass: "relative" },
                            [
                              _c("TextArea", {
                                attrs: {
                                  placeholder: "Tell us about you",
                                  error:
                                    _vm.$v.input.bio.$dirty &&
                                    !_vm.$v.input.bio.maxLength,
                                  maxlength: "2000",
                                  rows: "10"
                                },
                                model: {
                                  value: _vm.input.bio,
                                  callback: function($$v) {
                                    _vm.$set(_vm.input, "bio", $$v)
                                  },
                                  expression: "input.bio"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "absolute right-0 text-xs",
                                  staticStyle: { bottom: "15px", right: "15px" }
                                },
                                [_vm._v(_vm._s(_vm.input.bio.length) + "/2000")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col pt-2" },
                            [
                              _vm.$v.input.bio.$dirty &&
                              !_vm.$v.input.bio.maxLength
                                ? _c("text-error", {
                                    attrs: {
                                      text:
                                        "Maximum character for bio is 2000 characters."
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1367564550
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex w-1/2 flex-col" },
        [
          _vm.isArtist
            ? _c("form-item", {
                attrs: { label: "Bank Name" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("Input", {
                            attrs: { placeholder: "Bank Name" },
                            model: {
                              value: _vm.input.bank.bank,
                              callback: function($$v) {
                                _vm.$set(_vm.input.bank, "bank", $$v)
                              },
                              expression: "input.bank.bank"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2364975221
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isArtist
            ? _c("form-item", {
                attrs: { label: "Account Name" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("Input", {
                            attrs: { placeholder: "Account Name" },
                            model: {
                              value: _vm.input.bank.account_name,
                              callback: function($$v) {
                                _vm.$set(_vm.input.bank, "account_name", $$v)
                              },
                              expression: "input.bank.account_name"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  4218307533
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isArtist
            ? _c("form-item", {
                attrs: { label: "Account Number" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("Input", {
                            attrs: { placeholder: "Account Number" },
                            model: {
                              value: _vm.input.bank.account_number,
                              callback: function($$v) {
                                _vm.$set(_vm.input.bank, "account_number", $$v)
                              },
                              expression: "input.bank.account_number"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  4147348173
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isArtist
            ? _c("form-item", {
                attrs: { label: "Swift Code" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function() {
                        return [
                          _c("Input", {
                            attrs: { placeholder: "Swift Code" },
                            model: {
                              value: _vm.input.bank.swift_code,
                              callback: function($$v) {
                                _vm.$set(_vm.input.bank, "swift_code", $$v)
                              },
                              expression: "input.bank.swift_code"
                            }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1377713549
                )
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ac5438e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac5438e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/EditProfile.vue
// module id = null
// module chunks = 